import { withI18n } from 'react-i18next';
import TrackingMobileTable from './TrackingMobileTable';

export const pureComponent = TrackingMobileTable;
export default withI18n()(TrackingMobileTable);
